/**
 * 获取当前时间戳
 *
 * @returns {number} 当前时间戳
 *
 * getNowTime()
 * => 1610431852976
 */

function getNowTime() {
  return Date.now();
}
export default getNowTime;
